export default __webpack_public_path__ + "static/media/logo.516d2dfd.png";